export interface MonitorSystem {
  name: string;
}

export const toMonitorSystemConfig = (res: any): MonitorSystem => ({
  name: res?.name
})